// frontend/src/pages/AuthPage.jsx
// Page d'authentification - Wrapper pour AuthModule
// 73+ Papy - Décembre 2025

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthModule from '../modules/client/AuthModule';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const AuthPage = () => {
  const navigate = useNavigate();
  const { loginClient, loginAdmin, isAuthenticated, isAdminAuthenticated } = useAuth();
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);

  // Charger la configuration de la ferme
  useEffect(() => {
    const loadConfig = async () => {
      try {
        const response = await fetch(`${API_BASE}/configuration`);
        if (response.ok) {
          const result = await response.json();
          
          // Conversion tableau → objet
          const configObj = {};
          const configArray = result.data || result;
          
          if (Array.isArray(configArray)) {
            configArray.forEach(item => {
              configObj[item.param_name] = item.param_value;
            });
          } else if (typeof configArray === 'object') {
            Object.assign(configObj, configArray);
          }
          
          setConfig(configObj);
        }
      } catch (err) {
        console.error('Erreur chargement config:', err);
      } finally {
        setLoading(false);
      }
    };
    
    loadConfig();
  }, []);

  // Rediriger si déjà connecté
  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/catalog', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // ==========================================
  // HANDLER AUTHENTIFICATION CLIENT
  // ==========================================
  
  /**
   * Gère l'authentification client (email/QR + mot de passe)
   * @param {string} identifier - Email ou QR code
   * @param {string} type - 'email' ou 'qrcode'
   * @param {string} password - Mot de passe
   */
  const handleClientAuth = async (identifier, type, password) => {
    const result = await loginClient(identifier, type, password);
    
    if (result.success) {
      // Rediriger vers le catalogue
      navigate('/catalog', { replace: true });
    }
    
    return result;
  };

  // ==========================================
  // HANDLER AUTHENTIFICATION ADMIN
  // ==========================================
  
  /**
   * Gère l'authentification admin (login + mot de passe via HR_users)
   * @param {string} login - Identifiant admin
   * @param {string} password - Mot de passe
   */
  const handleAdminLogin = async (login, password) => {
    const result = await loginAdmin(login, password);
    
    if (result.success) {
      // Rediriger vers le dashboard admin
      navigate('/admin', { replace: true });
    }
    
    return result;
  };

  // ==========================================
  // RENDU
  // ==========================================
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <AuthModule
      onAuth={handleClientAuth}
      onAdminLogin={handleAdminLogin}
      config={config}
    />
  );
};

export default AuthPage;